// extracted by mini-css-extract-plugin
module.exports = {"viewport":"HomePage_viewport__2emnY"};